export default function SystemHealth() {
  return (
    <div>
      <h1 className="text-2xl font-semibold text-slate-800 mb-6">System Health</h1>
      <p className="text-slate-500 text-sm">Service uptime, error rates, active sessions, and log explorer.</p>
    </div>
  );
}
